import { render, staticRenderFns } from "./Design1.vue?vue&type=template&id=e62a5d90&scoped=true"
import script from "./Design1.vue?vue&type=script&lang=js"
export * from "./Design1.vue?vue&type=script&lang=js"
import style0 from "./Design1.vue?vue&type=style&index=0&id=e62a5d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62a5d90",
  null
  
)

export default component.exports